import { EyeOutlined } from '@ant-design/icons'
import {
  Card as ANTDCard,
  Avatar,
  Button,
  Collapse,
  Descriptions,
  Flex,
  Typography,
} from 'antd'
import { Link } from 'react-router-dom'
import { thirdParties, ThirdPartyProfile } from '../../models/ThirdParty'

const { Text } = Typography

interface Props {
  profil: ThirdPartyProfile
}
export const UserThirdPartyCard = ({ profil }: Props) => {
  const thirdParty = thirdParties[profil.thirdParty]

  return (
    <ANTDCard styles={{ body: { padding: 0 } }}>
      <Flex vertical>
        <Collapse
          ghost
          collapsible="icon"
          defaultActiveKey={[]}
          expandIconPlacement="end"
          expandIcon={() => (
            <Button variant="filled" color="default" icon={<EyeOutlined />}>
              More infos
            </Button>
          )}
          items={[
            {
              key: '1',
              label: (
                <Flex justify="space-between" align="center">
                  <Flex align="center" gap={8}>
                    <Avatar
                      shape="square"
                      size={30}
                      style={{ background: thirdParty.color }}
                      icon={
                        thirdParty.icon ? (
                          <thirdParty.icon
                            width={20}
                            height={20}
                            color={'#fff'}
                          />
                        ) : null
                      }
                    />
                    <Text strong>{thirdParty.name}</Text>
                  </Flex>
                </Flex>
              ),
              children: (
                <ANTDCard>
                  <Descriptions column={1} layout="vertical" size="small">
                    <Descriptions.Item label="Third Party User ID">
                      {profil.id && (
                        <Text copyable={{ text: String(profil.id) }}>
                          {profil.id}
                        </Text>
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                </ANTDCard>
              ),
            },
          ]}
        />
        <Flex className="w-full" style={{ padding: 12 }}>
          <Link className="w-full" to={profil.link ?? ''} target="_blank">
            <Button block type="primary" disabled={!profil.link}>
              View on {thirdParty.name}
            </Button>
          </Link>
        </Flex>
      </Flex>
    </ANTDCard>
  )
}

export type UserThirdPartyCardType = {
  ThirdPartyCard: typeof UserThirdPartyCard
}
